// src/checker/SectionChecker.ts
var SectionChecker = class {
  constructor(name, text, keyword, t) {
    this.name = name;
    this.text = text.toLowerCase();
    this.keyword = keyword.toLowerCase();
    this.score = 0;
    this.messages = [];
    this.t = t;
  }
  getResult() {
    return {
      name: this.name,
      score: this.score,
      messages: this.messages
    };
  }
  countScore(percentage) {
    return Math.round(this.score * percentage / 100);
  }
};
var AtomicChecker = class {
  constructor(code, text = "Bad text") {
    this.code = code;
    this.text = text;
    this.score = 0;
    this.status = "bad";
  }
  getResult() {
    return {
      code: this.code,
      score: this.score,
      status: this.status,
      text: this.text
    };
  }
};

export {
  SectionChecker,
  AtomicChecker
};
